import { render, staticRenderFns } from "./icon_mdi_account_box_multiple_outline.vue?vue&type=template&id=7b4f8f7a"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports